import React, { Fragment, useContext } from "react";
import { Helmet } from "react-helmet";
import { useQuery } from "react-query";
import { FetchEventsData } from "../api";
import HPreloader from "../components/loader/Hpreloader";
import { About, About2 } from "../components/Main/About";
import Bottomhero from "../components/Main/Bottomhero";
import Footer from "../components/Main/Footer";
import Header from "../components/Main/Header";
import { Home1 } from "../data/Lists";
import Errorpage from "../components/Main/Error";
import { LanguageContext } from "../App";
import TEXT from "../data/text";

const Home = () => {
  const { language } = useContext(LanguageContext);
  const results = useQuery(
    // results contains upcoming events
    {
      queryKey: ["events"],
      queryFn: () => FetchEventsData(),
      staleTime: 8000,
      refetchOnWindowFocus: false,
    }
  );
  if (results.isLoading) {
    return (
      <Fragment>
        <Helmet>
          <title>TCS Sustainathon</title>
        </Helmet>
        <HPreloader />
      </Fragment>
    );
  } else if (results.isError) {
    return (
      <Fragment>
        <Helmet>
          <title>{TEXT[language]["EVENTS"]["8"]}</title>
        </Helmet>
        <Errorpage />
      </Fragment>
    );
  } else if (results.data) {
    return (
      <React.Fragment>
        <Helmet>
          <title>TCS Sustainathon</title>
        </Helmet>
        <Header
          obj={Home1[language]}
          events={results}
          bgbanner={process.env.REACT_APP_HOME_TOP_BG}
        />
        <About2 />
        <About />
        <Bottomhero
          obj={Home1}
          botbanner={process.env.REACT_APP_HOME_BOTTOM_BG}
        />
        <Footer />
      </React.Fragment>
    );
  }
};

export default Home;
